import "./modal.scss";

export class Modal {
    constructor(name) {
        let findModal = null;

        Array.from(document.querySelectorAll('.modal')).forEach(item => {
            const init = parseInt(item.getAttribute('data-init'));
            const modalName = item.getAttribute('data-modal-name');
            const targetSelector = item.getAttribute('data-target');
            let modalInstance = null;

            if (item.parentElement !== document.body) {
                document.body.appendChild(item);
            }

            if (init === 0) {
                modalInstance = item._modal = new ModalMiddleware(item);
                item.setAttribute('data-init', 1);
            } else {
                modalInstance = item._modal;
            }

            if (modalName === name) {
                item._modal = findModal = modalInstance || new ModalMiddleware(item);
            }


            this._attachEvents(modalInstance, item, targetSelector, init);
        });

        return findModal;
    }

    _attachEvents(modal, node, targetSelector, hasInit) {
        if (!hasInit) {
            Array.from(document.querySelectorAll(targetSelector)).forEach(item => {
                item.addEventListener('click', () => {
                    modal.show();
                });
            });
        }

        node.addEventListener('click', event => {
            if (event.target.classList.contains('modal__space') || event.target.classList.contains('js-modal-close')) {
                modal.hide();
            }
        });
    }
}

export class ModalMiddleware {
    constructor(node) {
        this._node = node;
    }

    show() {
        this._node.classList.add('_show');
        document.body.style.overflow = 'hidden';
    }

    hide() {
        this._node.classList.remove('_show');
        document.body.style.overflow = '';
    }
}

export function getModalByName(name) {
    let result;
    Array.from(document.querySelectorAll('.modal')).forEach(item => {
        const modalName = item.getAttribute('data-modal-name');
        const modalInstance = item._modal;

        if (name === modalName) {
            result = modalInstance;
        }
    });

    return result;
}

setTimeout(() => {
    new Modal();
}, 0);